const DEFAULT_SUBSCRIPTION_ERROR = 'We could not subscribe you right now. Please try again.';
const NETWORK_ERROR = 'We could not reach the newsletter service. Please try again in a moment.';

async function readJsonBody(response) {
  const rawBody = await response.text();

  if (!rawBody) {
    return null;
  }

  try {
    return JSON.parse(rawBody);
  } catch (error) {
    return null;
  }
}

function getErrorMessage(payload) {
  if (!payload || typeof payload !== 'object') {
    return DEFAULT_SUBSCRIPTION_ERROR;
  }

  const directMessage = payload.message || payload.detail || payload.error;
  if (typeof directMessage === 'string' && directMessage.trim()) {
    return directMessage.trim();
  }

  if (Array.isArray(payload.errors) && payload.errors.length > 0) {
    const firstError = payload.errors[0];
    if (firstError && typeof firstError.message === 'string' && firstError.message.trim()) {
      return firstError.message.trim();
    }
  }

  return DEFAULT_SUBSCRIPTION_ERROR;
}

export async function subscribeToNewsletter(email) {
  const trimmedEmail = String(email || '').trim();

  if (!trimmedEmail) {
    throw new Error('Please enter a valid email address.');
  }

  const endpoint = process.env.REACT_APP_NEWSLETTER_ENDPOINT;

  if (!endpoint) {
    throw new Error(
      'Newsletter backend is not configured. Set REACT_APP_NEWSLETTER_ENDPOINT in your environment.'
    );
  }

  let response;

  try {
    response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: trimmedEmail }),
      credentials: 'omit',
    });
  } catch (error) {
    throw new Error(NETWORK_ERROR);
  }

  const payload = await readJsonBody(response);

  if (!response.ok) {
    throw new Error(getErrorMessage(payload));
  }

  if (payload && typeof payload === 'object') {
    return payload;
  }

  return { message: 'Thank you for subscribing!' };
}
